import store from './store'
import { computed } from '@vue/composition-api'

type StoreGetter = any
type StoreGetters = Record<string, StoreGetter>

export function useGetters(getters: Record<string, string>): StoreGetters {
  const _getters: StoreGetters = {}

  Object.keys(getters).forEach((propName: string) => {
    _getters[propName] = computed(() => store.getters[getters[propName]])
  })

  return _getters
}
